/* Associations search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface ISearchFiltersAssociationsState {
    keyword: string;
    associationId: any;
}

const initialState: ISearchFiltersAssociationsState = {
    keyword: '',
    associationId: '',
};

export function searchFiltersAssociationsReducer(state: ISearchFiltersAssociationsState = initialState, action: any): ISearchFiltersAssociationsState {
    switch (action.type) {
        case Actions.SEARCH_ASSOCIATIONS_KEYWORD:
            return _.merge({}, state, { keyword: action.keyword });
        case Actions.SEARCH_ASSOCIATIONS_ASSOCIATION_ID:
            return _.merge({}, state, { associationId: action.associationId });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersAssociationsReducer.tsx